import React, { useEffect, useRef, useState } from 'react'
import CertificateVerificationNavbar from './CertificateVerificationNavbar'
import CertificateVerificationDefaultBody from './CertificateVerificationDefaultMobileBody'
import CertificateVerificationFooter from './CertificateVerificationFooter'
import CertificateVerificationDefaultDesktopBody from './CertificateVerificationDefaultDesktopBody'
import CertificateVerificationDefaultMobileBody from './CertificateVerificationDefaultMobileBody'
import ReactPixel from "react-facebook-pixel";
import Constants from '../../common/constants'
import { Mixpanel } from '../../config/Mixpanel'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import DefaultNavbar from './DefaultComponents/DefaultNavbar'
import DefaultFooter from './DefaultComponents/DefaultFooter'
import { SET_LOCK_STATUS, SET_RESET_DATA } from '../../redux/actions/types'

const CertificateVerificationDefaultPage = ({}) => {
  const location = useLocation();
  const buttonStyles = {
    style1 : 'w-[142px] h-[41px] text-[#7fc241] border-2 border-[#7fc241] text-[16px] mr-1 ml-1 rounded-lg font-semibold w-[50%]',
    style2 : 'w-[142px] h-[41px] text-black bg-[#7fc241] border-2 border-[#7fc241] text-[16px] ml-1 mr-1  rounded-lg font-semibold w-[50%]'
  }
  
  const condition = false;
  const utmData = useSelector(store => store?.userActivity?.utm_data);
    const userDetails = useSelector(store => store?.certificateVerification?.userInfo);
  const dispatch = useDispatch();
  useEffect(()=>{
    ReactPixel.pageView();
  },[])


  useEffect(()=>{
   
    // Mixpanel.identify(email);
    Mixpanel.people.set({
      "utm_source": utmData?.utmSource,
      "utm_medium": utmData?.utmMedium,
      "utm_campaign": utmData?.utmCampaign,
      "utm_content": utmData?.utmContent,
      "utm_term": utmData?.utmTerm
    })
   
  },[])

  useEffect(()=>{

    dispatch({type : SET_LOCK_STATUS , payload: true})
    dispatch({type : SET_RESET_DATA , payload:  {
   userInfo : {
    name :"",
    email : "",
    role : "",
    role_data : "",
    role_headings :"",
    phone_number : ""
   },
   user_linked_url : "",
   user_type: "",
   is_locked: true,
   is_edit: false,
   certificateData : {},
   engagements : {},
   cvData:{},
   is_interview_requested : false,
   is_cv_requested : false
}})

  } ,[])

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    const error = urlParams.get("error");
    const type = urlParams.get("type");

    if (code) {
      // Store the code in localStorage
      localStorage.setItem("linkedin_auth_code", code);
      if(type === "share"){
        localStorage.setItem("linkedin_auth_type", 'share');
      } else {
        localStorage.setItem("linkedin_auth_type", 'login');
      }
      // If this is a popup window, send message to parent and close
      if (window.opener) {
        window.opener.postMessage(
          "linkedin_auth_complete",
          window.location.origin
        );
        // Delay close to ensure message is received
        setTimeout(() => {
          window.close();
        }, 500);
      } else {
        // Fallback: redirect to main app with code in URL (mobile)
        window.location.href = `/verify/certificate?code=${encodeURIComponent(code)}${type ? `&type=${encodeURIComponent(type)}` : ''}`;
      }
    } else if (error) {
      // Handle LinkedIn auth error
      console.error('LinkedIn auth error:', error);
      if (window.opener) {
        window.opener.postMessage(
          "linkedin_auth_error",
          window.location.origin
        );
        setTimeout(() => {
          window.close();
        }, 500);
      } else {
        // Redirect with error
        window.location.href = '/?error=' + encodeURIComponent(error);
      }
      localStorage.removeItem("linkedin_auth_code");
      localStorage.removeItem("linkedin_auth_type");
    }
    else{
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_DEFAULT_PAGE_LOADED);
    }
  }, [location]);

  function handlerCertified({utm_source,utm_medium}){
    window.open(`https://certified.learntube.ai/?utm_source=${utm_source}&utm_medium=${utm_medium}` , '_blank')
        
  }

  function handlerPersonalise({utm_source, utm_medium }){
    window.open(`https://personalise.learntube.ai?utm_source=${utm_source}&utm_medium=${utm_medium}`, '_blank')
  }


    const targetRef = useRef(null); // the div to observe
    const [isVisible, setIsVisible] = useState(true); // visibility state
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.1, // consider visible if at least 10% in view
        }
      );
  
      if (targetRef.current) {
        observer.observe(targetRef.current);
      }
  
      return () => {
        if (targetRef.current) {
          observer.unobserve(targetRef.current);
        }
      };
    }, []);

    const scrollRef  = useRef();
    const isLocked = useSelector((store)=> store?.certificateVerification?.is_locked);
    const isEdit = useSelector((store)=> store?.certificateVerification?.id_edit);

    useEffect(()=>{
      if(!isLocked || !isEdit){
        if(scrollRef?.current){
          scrollRef?.current?.scrollIntoView();
        }
      }

    },[isLocked,isEdit])

  return (
     <div
      classNam="w-full relative h-screen flex flex-col justify-center items-center"
      style={{
        backgroundImage: `radial-gradient(circle at center, #26496A 0%, #182C3F 100%)`,
      }}
    >
      <div className="p-4  pb-10 w-full flex flex-col justify-center items-center" ref={scrollRef}>
        <div className="w-full  md:max-w-2xl">
      <DefaultNavbar/>
     <CertificateVerificationDefaultMobileBody targetRef={targetRef} handlerCertified={handlerCertified} handlerPersonalise={handlerPersonalise}/>
     </div>
      </div>
       <div className="w-full flex flex-col justify-center items-center ">
        <div className="w-full md: max-w-2xl">
     <DefaultFooter handlerCertified={handlerCertified} handlerPersonalise={handlerPersonalise}/>
     </div>
     </div>
      {!isVisible && 
      <div className='sticky z-[999999] bottom-0  flex items-center justify-center '>
        <div className=" md:max-w-2xl w-full flex items-center justify-center bg-[#26588B] p-4">
        <button className={condition ? buttonStyles.style2 :  buttonStyles.style1 } onClick={(e)=> { handlerPersonalise({utm_source: 'certificate-verification-default', utm_medium:'build-course'});
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_DEFAULT_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED);
        
      
      }}>Build A Course</button>
        <button className={condition ? buttonStyles.style1 :  buttonStyles.style2 } onClick={(e)=> {
          Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_DEFAULT_STICKY_CTA_GET_CERTIFIED_CLICKED);
          handlerCertified({utm_source: 'certificate-verification-default', utm_medium:'get-certified'}) }} >Get Certified</button>
        </div>
      </div>}
    </div>
  )
}

export default CertificateVerificationDefaultPage
